import { Component, Input, OnInit, signal, ViewChild } from '@angular/core';
import { AccountRegistrationService } from '../../../services/account-registration.service';
import { ActivatedRoute } from '@angular/router';
import { IContactDetailsData } from '../../../interfaces/account-registration/contact-details-data.interface';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Constants, ICountry, ILookup, NewAccountType } from 'common';
import { validationGroup } from '../constants/registration.constants';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'acc-registration-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrl: './contact-details.component.scss',
})
export class ContactDetailsComponent implements OnInit {
  @Input() contactNumber: number = 1;
  @Input() formGroup: FormGroup<IContactDetailsData>;
  @Input() showRegulatoryCheckBox: boolean = false;
  openAllPanels: boolean = false;
  validationGroup = validationGroup;

  private subscription = new Subscription();

  salutations: ILookup[];
  countries: ICountry[];
  counties: ILookup[];

  showFields: boolean = true;
  maxDob: Date;
  NewAccountType = NewAccountType;
  accountType: NewAccountType;

  get formContactDetails(): FormGroup<IContactDetailsData> {
    switch (this.accountType) {
      case NewAccountType.Prs:
        return this.accountRegistrationService.formPrsContactDetails[this.contactNumber - 1];
      case NewAccountType.Radio:
        return this.accountRegistrationService.formRadioContactDetails;
    }
  }

  constructor(
    private readonly accountRegistrationService: AccountRegistrationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.salutations = this.route.snapshot.data.salutations;
    this.countries = this.route.snapshot.data.countries;
    this.counties = this.route.snapshot.data.counties;
    this.setMaxDateOfBirth();
    this.registerListeners();
  }

  showHeaderError = (group: string[]): boolean =>
    group.some((prop) => {
      const control = this.formContactDetails?.get(prop);
      return control?.invalid && control?.touched;
    });

  countryChanged(value: string) {
    if (value.toLowerCase() === Constants.irelandCountryString.toLocaleLowerCase()) {
      this.formContactDetails.controls.county.enable();
    } else {
      this.formContactDetails.controls.county.setValue(null);
      this.formContactDetails.controls.county.disable();
    }
  }

  copyGeneralToContact() {
    this.accountRegistrationService.copyGeneralToContact(this.accountType, this.contactNumber);
    this.countryChanged(this.formContactDetails.controls.country.value);
    this.formContactDetails.markAllAsTouched();
    this.openAllPanels = true;
  }

  registerListeners(): void {
    this.subscription.add(
      this.accountRegistrationService.accountType$.subscribe((accountType: NewAccountType) => {
        this.accountType = accountType;
        if (this.accountType === NewAccountType.Prs) {
          this.formContactDetails.controls.positionHeld.addValidators([Validators.required]);
        } else if (this.accountType === NewAccountType.Radio) {
          this.formContactDetails.controls.positionHeld.clearValidators();
        }
      })
    );
  }

  headerCheckboxChanged(checked: boolean) {
    if (this.showRegulatoryCheckBox) {
      this.showFields = !checked;
      this.accountRegistrationService.setContactSameAsOther(this.formContactDetails, checked);
    }
  }

  private setMaxDateOfBirth() {
    const today = new Date();
    this.maxDob = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  }
}
